import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { CantidadPorEstadoDto } from '@models/base/cantidadPorEstadoDto.mode';
import { RangoFechasValores } from '@models/base/identificadores.model';
import { ExpedienteService } from '@services/expediente/expediente.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DashboardExpedienteComponent } from '@views/expedientes/dashboard-expediente/dashboard-expediente.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { map } from 'rxjs';
import { DashboardExpedientesComponent } from '../dashboard-expedientes/dashboard-expedientes.component';
import { MatTabsModule } from '@angular/material/tabs';
import { DashboardTareasComponent } from '../dashboard-tareas/dashboard-tareas.component';
import { DashboardMovimientosComponent } from '../dashboard-movimientos/dashboard-movimientos.component';
import { MatIconModule } from '@angular/material/icon';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { DashboardInicioComponent } from '../dashboard-inicio/dashboard-inicio.component';

@Component({
  standalone: true,
  imports: [MatButtonModule, MatButtonToggleModule, MatCardModule,
    MatDividerModule,
    MatButtonModule,
    RouterModule,
    NgxSpinnerModule,
    MatTabsModule,
    MatIconButton,
    MatIconModule,
    CommonModule,
    DashboardTareasComponent,
    DashboardMovimientosComponent,
    DashboardExpedientesComponent,
    AppRolesDirective,
    DashboardInicioComponent],
  selector: 'app-dashboard-general',
  templateUrl: './dashboard-general.component.html',
  styleUrls: ['./dashboard-general.component.css'],
  providers: [DatePipe],
})
export class DashboardGeneralComponent {
  cardLayout: any;

  formBuilder: FormBuilder = new FormBuilder();
  form!: FormGroup;
  cantidadPorEstadoDto: CantidadPorEstadoDto[] = [];
  cantidadPorEstadoPeritoDto: CantidadPorEstadoDto[] = [];
  cantidadPorTipoDto: CantidadPorEstadoDto[] = [];
  constructor(
    private expedienteService: ExpedienteService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver
  ) { }

  ngOnInit(): void {

  }

}
